import { render, staticRenderFns } from "./StructureTreePanel.vue?vue&type=template&id=018b25b6&scoped=true"
import script from "./StructureTreePanel.vue?vue&type=script&lang=js"
export * from "./StructureTreePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b25b6",
  null
  
)

export default component.exports